import "antd/dist/antd.css";
//import {Table} from "antd";
import NavBar from "../NavBar/navbar";
//import React, {useState} from 'react';
import axios from 'axios';
import { useLocation } from "react-router-dom";
import {Grid,Row,Col, Container, Button} from 'react-bootstrap';
import {Form as FormR}  from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import FinCard from '../FinCard/fincard'
import "./invoiceHeader.css"
//httpss://react-bootstrap.github.io/components/cards/


import React, { useContext, useEffect, useRef, useState } from 'react';
import {  Input, Popconfirm, Form, Table,Typography  } from 'antd';
import SubNavBar from "../SubNavBar/subnavbar";
import { getTokenUser } from "../../helper/token";

function InvoiceHeader(){


  //#region State management
  
  const state = useLocation();
  const SERVER_URL = process.env.REACT_APP_PROD_SERVER_URL;
  const [loggedInUser,setLoggedInUser] = useState(getTokenUser());
  axios.defaults.headers.common['Authorization'] = loggedInUser.token;
  const invoiceId = state.state.split('-')[0];
  const [invoiceHeader,setInvoiceHeader] = useState({});
  const [dataSource,setDataSource] = useState([]);
  const [isPageEdited,setPageEdited] = useState(false);
  const [subNavValues,setSubNavValues] = useState([]);

  //#endregion

  //#region column definitions

        const InvoiceLineColumns=[
        {
            title: "Invoice Line Description",
            dataIndex:"invoice_line_description",
            editable: true,
        },
        {
            title:"Invoice Line Quantity",
            dataIndex:"invoice_line_quantity",
            editable: true,
        },
        {
            title:"Invoice Line Unit Value",
            dataIndex:"invoice_line_unit_value",
            editable: true,
        },
        {
            title:"Invoice Line Total Exc",
            dataIndex:"invoice_line_total_exc",
            editable: true,
        },
        {
            title:"Invoice Line Total Inc",
            dataIndex:"invoice_line_total_inc",
            editable: true,
        },
        {
            title:"Invoice Line Notes",
            dataIndex:"invoice_line_notes",
            editable: true,
        },];

    //#endregion

  //#region Ant Table States & Functions


  const EditableContext = React.createContext(null);
      

  const EditableRow = ({ index, ...props }) => {
    const [form] = Form.useForm();
    return (
      <Form form={form} component={false}>
        <EditableContext.Provider value={form}>
          <tr {...props} />
        </EditableContext.Provider>
      </Form>
    );
  };

  const EditableCell = ({
    title,
    editable,
    children,
    dataIndex,
    record,
    handleSave,
    ...restProps
  }) => {
    const [editing, setEditing] = useState(false);
    const inputRef = useRef(null);
    const form = useContext(EditableContext);
    useEffect(() => {
      if (editing) {
        inputRef.current.focus();
      }
    }, [editing]);
    const toggleEdit = () => {
      setEditing(!editing);
      form.setFieldsValue({
        [dataIndex]: record[dataIndex],
      });
    };
    const save = async () => {
      try {
        const values = await form.validateFields();
        toggleEdit();
        handleSave({
          ...record,
          ...values,
        });
      } catch (errInfo) {
        console.log('Save failed:', errInfo);
      }
    };
    let childNode = children;
    if (editable) {
      childNode = editing ? (
        <Form.Item
          style={{
            margin: 0,
          }}
          name={dataIndex}
          rules={[
            {
              required: true,
              message: `${title} is required.`,
            },
          ]}
        >
          <Input ref={inputRef} onPressEnter={save} onBlur={save} />
        </Form.Item>
      ) : (
        <div
          className="editable-cell-value-wrap"
          style={{
            paddingRight: 24,
          }}
          onClick={toggleEdit}
        >
          {children}
        </div>
      );
    }
    return <td {...restProps}>{childNode}</td>;
  };

  const components = {
    body: {
      row: EditableRow,
      cell: EditableCell,
    },
  };

  const columns = InvoiceLineColumns.map((col) => {
      if (!col.editable) {
          return col;
      }
      return {
          ...col,
          onCell: (record) => ({
          record,
          editable: col.editable,
          dataIndex: col.dataIndex,
          title: col.title,
          handleSave,
          }),
      };
  });

  //#endregion

  //#region Populate UI

  React.useEffect(()=>{

      console.log(invoiceId);
      axios
      .get(SERVER_URL+'/api/InvHeaders/GetInvoiceHeader?invoiceHeaderId='+invoiceId,)
      .then((response) => {
          console.log(response.data);
          let header = response.data
          let tempInvoiceHeader = {invoice_description:header.InvDesc,
              invoice_create_date:header.InvCreateDate.substring(0,10),
              invoice_date:header.InvDate.substring(0,10),
              invoice_total_exc:header.InvTotalExc,
              invoice_sent:header.InvSent,
              invoice_paid:header.InvPaid,
              invoice_date_paid:header.InvDatePaid.substring(0,10),
              invoice_ref:header.InvRef,
              invoice_notes:header.InvNotes,
              invoiceLines:[]}
              //console.log(header.InvLine);
              header.InvLine.forEach(line=>{
                  let tempLine={
                      key:line.InvLineId,
                      invoice_line_description:line.InvLineDesc,
                      invoice_line_quantity:line.InvLineUnitQty,
                      invoice_line_unit_value:line.InvLineUnitValue,
                      invoice_line_total_exc:line.InvLineTotalExc,
                      invoice_line_total_inc:line.InvLineTotalInc,
                      invoice_line_notes:line.InvLineNotes,
                      invoice_line_type:'server'
                  }
                  tempInvoiceHeader.invoiceLines.push(tempLine);
              })
          setDataSource(tempInvoiceHeader.invoiceLines);
          console.log(dataSource);
          setInvoiceHeader(tempInvoiceHeader);
          // setCustomer({name: response.data.CustName,
          //      email: response.data.CustEmail,
          //      address:response.data.CustAddress,
          //      registration_number: response.data.CustRegNo,
          //      vat_number: response.data.CustVatNo,
          //      contact_mobile: response.data.CustContactNo,
          //      payment_term: response.data.CustPaymentTerms,
          //      status:response.data.CustStatus})
      })
      .catch(error => {
        console.log(error);
      });

      setSubNavValues([]);

      axios
      .get(SERVER_URL+'/api/Summary/GetRelatedProject?invoiceID='+ invoiceId,
      )
      .then((response) => {
          setSubNavValues(oldSubNavValues => [...oldSubNavValues, {heading: "Project", text: response.data.value}] );

          axios
          .get(SERVER_URL+'/api/Summary/GetRelatedCustomer?invoiceID='+ invoiceId,
          )
          .then((response) => {
              setSubNavValues(oldSubNavValues => [...oldSubNavValues, {heading: "Customer", text: response.data.value}] );

              axios
              .get(SERVER_URL+'/api/Summary/GetRelatedAccountManager?invoiceID='+ invoiceId,
              )
              .then((response) => {
                  setSubNavValues(oldSubNavValues => [...oldSubNavValues, {heading: "Account Manager", text: response.data.value}] );
              })
          })
      })
      .catch(error => {
          console.log(error);
      });

  },[]);
  //#endregion

  //#region functions

function SaveTable(){
    try {
        console.log("saved");
        console.log(dataSource);

            let postedData = [];
        dataSource.forEach(line=>{
            console.log(invoiceId);

            if(isNaN(parseInt(invoiceId))|isNaN(parseFloat(line.invoice_line_quantity))|isNaN(parseFloat(line.invoice_line_unit_value))|isNaN(parseFloat(line.invoice_line_total_exc))|isNaN(parseFloat(line.invoice_line_total_inc)) ){
                throw new Error('ValidationError');
            }
            let tempLine={
                InvLineId:line.key,
                InvLineDesc:line.invoice_line_description,
                InvId:parseInt(invoiceId),
                InvLineUnitQty:parseInt(line.invoice_line_quantity),
                InvLineUnitValue:parseFloat(line.invoice_line_unit_value),
                InvLineTotalExc:parseFloat(line.invoice_line_total_exc),
                InvLineTotalInc:parseFloat(line.invoice_line_total_inc),
                InvLineNotes:line.invoice_line_notes,
                InvLineType:line.invoice_line_type
            }
            postedData.push(tempLine);
        })
        console.log(postedData);
        axios
        .post(SERVER_URL+'/api/InvHeaders/SaveInvoiceLines',
        postedData
        ).then((response)=>{
            console.log(response);
            alert("Success");
        }).catch((Error)=>{
            if(Error =='ValidationError'){
                console.log(Error);
            }
            console.log(Error);
        });
    } catch (errInfo) {
      console.log('Validate Failed:', errInfo);
    }
};

function onInvoiceHeaderChange(invoiceChange)
{

    console.log("Change");

    switch (invoiceChange.attribute) {

        case "proposal_name":
            setInvoiceHeader({...invoiceHeader, invoice_description: invoiceChange.value});
            break;

        case "invoice_create_date":
            setInvoiceHeader({...invoiceHeader, invoice_create_date: invoiceChange.value});
            break;

        case "invoice_date":
            setInvoiceHeader({...invoiceHeader, invoice_date: invoiceChange.value});
            break;

        case "invoice_total_exc":
            setInvoiceHeader({...invoiceHeader, invoice_total_exc: invoiceChange.value});
            break;

        case "invoice_sent":
            setInvoiceHeader({...invoiceHeader, invoice_sent: invoiceChange.value});
            break;
    
        case "invoice_paid":
            setInvoiceHeader({...invoiceHeader, invoice_paid: invoiceChange.value});
            break;

        case "invoice_date_paid":
            setInvoiceHeader({...invoiceHeader, invoice_date_paid: invoiceChange.value});
            break;

        case "invoice_ref":
            setInvoiceHeader({...invoiceHeader, invoice_ref: invoiceChange.value});
            break;

        case "invoice_notes":
            setInvoiceHeader({...invoiceHeader, invoice_notes: invoiceChange.value});
            break;

        default:
            break;
    }
}

const handleDelete = (key) => {
  const newData = dataSource.filter((item) => item.key !== key);
  setDataSource(newData);
};

const handleSave = (row) => {
  setPageEdited(true);
  const newData = [...dataSource];
  const index = newData.findIndex((item) => row.key === item.key);
  const item = newData[index];
  newData.splice(index, 1, {
    ...item,
    ...row,
  });
  setDataSource(newData);
};

// const handleAdd = () => {
//   const newData = {
//     key: dataSource[dataSource.length-1].key+1,
//     invoice_line_description:"Description example",
//     invoice_line_quantity: 0,
//     invoice_line_unit_value: 0,
//     invoice_line_total_exc:0,
//     invoice_line_total_inc:0,
//     invoice_line_notes:"Notes example",
//     invoice_line_type:'client',
//   };
//   setDataSource([...dataSource, newData]);
// };

function onInvoiceHeaderFormSubmitHandler(event)
  {
    event.preventDefault();
        
    let updatedInvoiceHeader = {
        InvId: parseInt(invoiceId),
        
        InvDesc: event.target.elements.InvDesc.value,
        InvCreateDate: event.target.elements.InvCreateDate.value,
        InvDate: event.target.elements.InvDate.value,
        InvTotalExc: parseFloat(event.target.elements.InvTotalExc.value),
        InvSent: event.target.elements.InvSent.value,
        InvPaid: event.target.elements.InvPaid.value,
        InvDatePaid: event.target.elements.InvDatePaid.value,
        InvRef: event.target.elements.InvRef.value,
        InvNotes: event.target.elements.InvNotes.value,
        };

    axios
    .post(SERVER_URL+'/api/InvHeaders/UpdateInvoiceHeader',
    updatedInvoiceHeader
    )
    .then((response) => {
      alert("Success");
    })
    .catch(error => {
      console.log(error);
    });
  }

  function GetNewRowKey(listItems){
    let biggestKey = 0;
    listItems.forEach(element => {
        if(element.key>biggestKey){
            biggestKey=element.key;
        }
    });
    biggestKey = biggestKey+1;
    return biggestKey;
}

  const handleAdd = () => {
    const newData = {
      key: GetNewRowKey(dataSource),
      invoice_line_description:"Description example",
      invoice_line_quantity: 0,
      invoice_line_unit_value: 0,
      invoice_line_total_exc:0,
      invoice_line_total_inc:0,
      invoice_line_notes:"Notes example",
      invoice_line_type:'client',
    };
    setDataSource([...dataSource, newData]);
  };

//#endregion
    
  return(
        <div>
            <NavBar/>
            <SubNavBar values={subNavValues}></SubNavBar>
            <Container fluid>
                <Row>
                    <Col xs={1}>
                    </Col>
                    <Col xs={4}>
                        <div id="invoice-body-form">
                            <p className='customer-body-details-heading'>Invoice Information</p>
                            <FormR onSubmit={onInvoiceHeaderFormSubmitHandler}>
                                <FormR.Group className="mb-3" id="formBasicUsername">
                                    <div className='row justify-content-center invoice-input-row'>
                                        <div className='col-12'>
                                            <h2 className='invoice-input-title'>Description</h2>
                                            <FormR.Control id="InvDesc" type="text" defaultValue={invoiceHeader.invoice_description} onChange={(e) => {onInvoiceHeaderChange({attribute: "invoice_description", value: e.target.value})}}></FormR.Control>
                                        </div>
                                    </div>
                                    <div className='row justify-content-center invoice-input-row'>
                                        <div className='col-6'>
                                            <h2 className='invoice-input-title'>Create Date</h2>
                                            <FormR.Control id="InvCreateDate" type="date" defaultValue={invoiceHeader.invoice_create_date} onChange={(e) => {onInvoiceHeaderChange({attribute: "invoice_create_date", value: e.target.value})}}></FormR.Control>
                                        </div>
                                        <div className='col-6'>
                                            <h2 className='invoice-input-title'>Invoice Date</h2>
                                            <FormR.Control id="InvDate" type="date" defaultValue={invoiceHeader.invoice_date} onChange={(e) => {onInvoiceHeaderChange({attribute: "invoice_date", value: e.target.value})}}></FormR.Control>
                                        </div>
                                    </div>
                                    <div className='row justify-content-center invoice-input-row'>
                                        <div className='col-6'>
                                            <h2 className='invoice-input-title'>Total Exc</h2>
                                            <FormR.Control id="InvTotalExc" type="number" defaultValue={invoiceHeader.invoice_total_exc} onChange={(e) => {onInvoiceHeaderChange({attribute: "invoice_total_exc", value: e.target.value})}}></FormR.Control>
                                        </div>
                                        <div className='col-6'>
                                            <h2 className='invoice-input-title'>Invoice Sent?</h2>
                                            <FormR.Control id="InvSent" type="text" defaultValue={invoiceHeader.invoice_sent} onChange={(e) => {onInvoiceHeaderChange({attribute: "invoice_sent", value: e.target.value})}}></FormR.Control>
                                        </div>
                                    </div>
                                    <div className='row justify-content-center invoice-input-row'>
                                        <div className='col-6'>
                                            <h2 className='invoice-input-title'>Invoice Paid?</h2>
                                            <FormR.Control id="InvPaid" type="text" defaultValue={invoiceHeader.invoice_paid} onChange={(e) => {onInvoiceHeaderChange({attribute: "invoice_paid", value: e.target.value})}}></FormR.Control>
                                        </div>
                                        <div className='col-6'>
                                            <h2 className='invoice-input-title'>Date Paid</h2>
                                            <FormR.Control id="InvDatePaid" type="date" defaultValue={invoiceHeader.invoice_date_paid} onChange={(e) => {onInvoiceHeaderChange({attribute: "invoice_date_paid", value: e.target.value})}}></FormR.Control>
                                        </div>
                                    </div>
                                    <div className='row justify-content-center invoice-input-row'>
                                        <div className='col-6'>
                                            <h2 className='invoice-input-title'>Invoice Reference</h2>
                                            <FormR.Control id="InvRef" type="text" defaultValue={invoiceHeader.invoice_ref} onChange={(e) => {onInvoiceHeaderChange({attribute: "invoice_ref", value: e.target.value})}}></FormR.Control>
                                        </div>
                                        <div className='col-6'>
                                            <h2 className='invoice-input-title'>Notes</h2>
                                            <FormR.Control id="InvNotes" type="text" defaultValue={invoiceHeader.invoice_notes} onChange={(e) => {onInvoiceHeaderChange({attribute: "invoice_notes", value: e.target.value})}}></FormR.Control>
                                        </div>
                                    </div>
                                    <div className='row justify-content-center invoice-button-row'>
                                        <div className='col-4'>
                                            <Button variant="success" className="invoice-input-button" type="submit">
                                                Update
                                            </Button>
                                        </div>
                                    </div>
                                </FormR.Group>
                            </FormR>
                        </div>
                    </Col>
                    <Col xs={6}>
                            <h3>Invoice Line(s)</h3>
                            {/* <Button
                                onClick={handleAdd}
                                type="primary"
                                style={{
                                marginBottom: 16,
                                }}
                            >Add Row</Button> */}
                            {/* <Button
                                onClick={SaveTable}
                                type="primary"
                                style={{
                                marginBottom: 16,
                                }}
                            >Save Changes</Button> */}
                            <Table
                                components={components}
                                columns={columns} 
                                footer={() => <div><Button onClick={handleAdd} type="primary" style={{marginBottom: 16,}}>Add Row</Button></div>}
                                rowClassName={() => 'editable-row'}
                                bordered
                                pagination={{ position: ["none", "none"] }} 
                                dataSource={dataSource}>
                            </Table>
                    </Col>
                    <Col xs={1}>
                    </Col> 
                </Row>
                <div id="hover-save-button">
                  <p onClick={SaveTable} id="hover-save-button-text">Save Changes</p>
                </div>
            </Container>
        </div>
    );
}

export default InvoiceHeader;